module.exports = __webpack_public_path__ + "img/szb-logo.d13719e6.png";